import styles from "./styles.module.scss";

import { IconCard, IconCardCheckbox } from "../../../../shared";

import { useState } from "react";
import { Button } from "../../../../../../common";

const data = [
  {
    value: "Cardiovascular disease",
    displayValue: "Cardiovascular disease"
  },
  {
    value: "Anxiety disorder",
    displayValue: "Anxiety disorder"
  },
  {
    value: "Depression",
    displayValue: "Depression"
  },
  {
    value: "ADHD",
    displayValue: "ADHD"
  },
  {
    value: "Other mental disorder",
    displayValue: "Other mental disorder"
  },
  {
    value: "Diabetes",
    displayValue: "Diabetes"
  },
  {
    value: "Gastrointestinal disorder",
    displayValue: "Gastrointestinal disorder"
  },
  {
    value: "Cancer",
    displayValue: "Cancer"
  },
  {
    value: "Physical disability ",
    displayValue: "Physical disability "
  },
  {
    value: "Other",
    displayValue: "Other"
  }
];
export const SufferFromConditions = ({ onNextStep, onTrackEvent }) => {
  const [checked, setChecked] = useState([]);

  const handleCheck = (value) => {
    setChecked((prevState) => {
      if (prevState.includes(value)) {
        return prevState.filter((item) => item !== value);
      }
      return [...prevState, value];
    });
  };

  const handleNextStep = () => {
    onNextStep(checked);
    onTrackEvent(checked);
  };

  const handleSkip = () => {
    onNextStep();
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>Do you suffer from any of the following conditions?</h2>
        <p className={styles.hint}>
          By providing us with this information, we will be able to give you
          somatic exercise advice
        </p>
        <div className={styles.cardsWithImage}>
          <div className={styles.cards}>
            <IconCard
              fullWidth
              active={checked.length === data.length}
              onClick={handleSkip}
              title="No, I don't"
            />
            {data.map((value) => (
              <IconCardCheckbox
                fullWidth
                checked={checked.includes(value.value)}
                onClick={() => handleCheck(value.value)}
                title={value.displayValue}
                key={value.value}
              />
            ))}
          </div>
        </div>
      </div>
      <div className={styles.action}>
        <Button disabled={!checked.length} onClick={handleNextStep}>
          Continue
        </Button>
      </div>
    </div>
  );
};
